/* @flow */
import Collection from 'lib/Collection';
import Group from 'entities/Group';
import Subscription from 'entities/Subscription';

class Subscriptions extends Collection {
  initialize() {
    this.url = '/subscriptions';
    this.model = Subscription;
  }

  comparator(a: Subscription, b: Subscription) {
    const nameA = a.getGroup().getName();
    const nameB = b.getGroup().getName();
    return nameA.localeCompare(nameB);
  }

  getGroupIds() {
    return this.map(subscription => subscription.getGroupId());
  }

  getSubscriptionForGroup(group: Group) {
    const groupId = group.id;
    return this.find(subscription => subscription.getGroupId() === groupId);
  }

  removeSubscriptionForGroup(group: Group) {
    const subscription = this.getSubscriptionForGroup(group);
    if (subscription) {
      this.remove(subscription);
    }
  }
}

export default Subscriptions;



// WEBPACK FOOTER //
// ./src/collections/Subscriptions.js